// filepath: /C:/Users/nitis/Desktop/uii/client/src/components/shared/Notification.js
import { useEffect } from 'react';
import './notification.css';

const Notification = ({ message, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 3000); // Close the notification after 10 seconds

        return () => clearTimeout(timer);
    }, [onClose]);

    return (
        <div className="notification">
            {message}
        </div>
    );
};

export default Notification;